import React from 'react';
import fr from 'facet-rest';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import { PrimaryActionButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/PrimaryActionButtonRel';
import { WizardBackButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/WizardBackButtonRel';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { dataAttrs } from 'Helpers/Testing';

export const AccountOpeningV2WaitStepLayout = () => {
  const { resource } = useMetaLayoutContext();
  const { loadPageContentLink } = usePageContentContext();

  return (
    <FDStack spacing={3} direction="column">
      <MetaControlField attr="title" />
      <MetaControlField attr="description" />
      <LottieRel relationship={resource.relationship(fr.relationships.lottie.name)} />
      <MetaLayoutRemainingFields noAccordion />
      <FDStack direction="column" alignItems="center" spacing={2}>
        <FDStack direction="row" justifyContent="center" alignItems="center" spacing={2}>
          <WizardBackButtonRel resource={resource} overrideOnClick={(_, rel) => loadPageContentLink(rel.link('related'))} />
          <PrimaryActionButtonRel
            {...dataAttrs('continue-btn', resource)}
            relationship={resource.relationship(fr.relationships.homePage.name)}
          />
        </FDStack>
      </FDStack>
    </FDStack>
  );
};
